import React from 'react';
import { Box, Flex, Heading, Subhead } from 'rebass';
import styled from 'styled-components';
import { withProps } from 'recompose';
import Details from '../Details';
import Lead from '../Lead';
import theme from '../app/themes';

const base = withProps({
  py: 3,
  pl: 2,
  f: 5,
});

const Title = styled(base(Heading))`
  border-top: 10px solid ${theme.colors.black};
  letter-spacing: -0.9px;
`;

const Subtitle = styled(base(Subhead))`
  letter-spacing: 0.9px;
`;

export default () => (
  <div>
    <Details
      withGoBack={false}
    >
      <Flex
        column
        mt="-28px"
        mb={5}
      >
        <Title is="h1">
          We build web & mobile products.
        </Title>
        <Subtitle
          is="h2"
          bg="black"
          color="white"
        >
          Results in weeks, not years.
        </Subtitle>
      </Flex>
      <Details.Paragraph emoji="🖥️" title="Web and mobile development">
        We produce top quality web and mobile applications for our clients, for almost
        10 years. We&apos;ve worked with startups and universities from all over the world. We are
        experts in front-end development using <strong>React</strong> and Ember. We write
        high-quality <strong>Javascript</strong>, <strong>Elixir</strong> and Ruby code.
      </Details.Paragraph>
      <Details.Paragraph emoji="🎨" title="Product design">
        We take a user-centered design approach, constantly striving for simplified interfaces and
        functional products that look great. The customer perspective and needs guide our entire
        design process.<br />
        We work with our clients to develop a common and deep understanding of the
        problem, the business model, the customer, and the value proposition. We work in small
        design sprints to eliminate unknowns and ensure we meet our clients and their
        customers needs: ideation, build, test, learn & adapt, repeat.
      </Details.Paragraph>
      <Details.Paragraph emoji="🎯" title="Fast results">
        We thrive on deadlines and tight schedules, and work hard to ensure the product is delivered
        on time. Over the years we have developed several automation tools that help us get the
        job done faster.<br />
        When needed, we take the shortest path from start to delivery,
        using powerful frameworks that provide a lot out of the box,
        such as <strong>Wordpress</strong>, <strong>Firebase</strong>, and Shopify. We use tools
        like Github, Slack, Jira, and Google Apps to maximize our efficiency, and a Continuous
        Integration development approach, to release features several times a day.
      </Details.Paragraph>
      <Box mt={4}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/index.js